import { Skeleton } from '@mui/material';
import { BackpackIcon, CaretLeftIcon, Cross2Icon, DragHandleDots2Icon } from '@radix-ui/react-icons';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { RETIRER_TECHNICIEN, TECHNICIEN_PAR_EQUIPE } from '../../Utils/constant';
import { AddTech } from '../../components/utilisateur/AddTech';
import { disable } from '../../services/service';
import { useStoreAgent } from '../../store/agentStore';

export const DetailEquipe = () => {
    const [selectItemId, setSelectItemId] = useState("")
    const { id, equipe } = useParams();
    const technicien = useStoreAgent()
    useEffect(() => {
        technicien.technicienParEquipe(`${TECHNICIEN_PAR_EQUIPE}/${id}?page=0&param=&size=8`)
    }, [])

    return (
        <div className=''>
            <div className="lg:flex gap-4 items-center">
                <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
                <h1 className='font-mtn text-4xl font-bold'>{equipe}</h1>
            </div>
            <div className='flex items-center mt-4'>
                <input onChange={(e) => {
                }} type="text" placeholder="Recherche..." className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                />

                <button onClick={() => {
                    document.getElementById('add_Tech').showModal()
                }
                } className="ml-auto btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                    Ajouter un technicien
                </button>
                <dialog id="add_Tech" className="modal rounded-none">
                    <div className="modal-box w-10/12 max-w-xl h-3/5">
                        <div className="modal-action">
                            <h1 className='mr-auto text-2xl font-bold font-mtn'>
                                Ajouter un technicien
                            </h1>
                            <form method="dialog">
                                <button id='close' className="btn btn-sm"><Cross2Icon /></button>
                            </form>
                        </div>
                        <AddTech libelle={equipe} id={id}/>
                    </div>
                </dialog>
            </div>

            <div className='grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                {
                    technicien?.technicien?.data?.length === 0 ? 'aucune donnée' : technicien?.technicien?.data?.length !== 0 && technicien.loading ? (
                        technicien?.technicien?.data?.map((item) => (
                            <div className="bg-white shadow-sm border border-gray-200 rounded">
                                <div className="relative py-8 px-4">
                                    <div className="mx-auto  bg-slate-200 w-20 h-20 rounded-full"></div>
                                    <div className="text-center">
                                        <h4 className="text-lg font-extrabold truncate">{item.nomPrenoms}</h4>
                                        <h4 className="text-sm">{item?.profile?.toLowerCase()}</h4>
                                    </div>
                                    <div className="mt-4 mb-3 space-y-3">
                                        <p className="text-xs gap-2 flex"><DragHandleDots2Icon />{item.numero}</p>
                                        <p className="text-xs gap-2 flex"> <BackpackIcon />{item.email}</p>
                                    </div>
                                    <div className="flex justify-center mt-8">
                                        <button onClick={() => {
                                            setSelectItemId(item.id)
                                            document.getElementById('delete_tech').showModal()
                                        }} className='border-none hover:bg-amber-200 btn btn-sm bg-amber-200 text-slate-900'>Retirer</button>
                                        <dialog id="delete_tech" className="modal">
                                            <div className="modal-box max-w-md rounded-lg">
                                                <h3 className="font-extrabold text-xl text-red-600 ">
                                                    Attention
                                                </h3>
                                                <p className="pt-2 text-black font-medium">
                                                    Voulez vous vraiment effectuer cette action ?
                                                </p>
                                                <div className="modal-action">
                                                    <form
                                                        method="dialog"
                                                        className="w-full flex items-center justify-end gap-x-4"
                                                    >
                                                        <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                            Annuler
                                                        </button>
                                                        <button onClick={() => {
                                                            disable(RETIRER_TECHNICIEN, selectItemId).then(() => {
                                                                toast.success(`${item.nomPrenoms + ' rétiré'}`)
                                                                technicien.technicienParEquipe(`${TECHNICIEN_PAR_EQUIPE}/${id}?page=0&param=&size=8`)
                                                            }).catch((err) => {

                                                            })
                                                        }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                            Retirer
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                        </dialog>

                                    </div>
                                </div>
                            </div>
                        ))
                    ) :
                        [1, 2, 3, 4].map(() => (
                            <div className="bg-white shadow-sm border border-gray-200 rounded">
                                <div className="relative py-8 px-4">
                                    <div className="mx-auto  bg-slate-200 w-20 h-20 rounded-full"></div>
                                    <div className="flex justify-center">
                                        <div>
                                            <h4 className="text-lg font-extrabold truncate"><Skeleton className='' height={20} width={140} /></h4>
                                            <h4 className="text-sm"><Skeleton width={130} height={20} /></h4>
                                        </div>

                                    </div>
                                    <div className="mt-8 mb-3 space-y-3">
                                        <Skeleton className='text-center' width={170} />
                                        <Skeleton className='text-center' width={120} />
                                    </div>
                                    <div className="flex justify-center mt-8">
                                        <Skeleton width={70} height={30} variant='rounded' />
                                    </div>
                                </div>
                            </div>
                        ))
                }
            </div>
        </div>
    )
}
